import {CONSTANTS} from '@/constants'

export default function(h, row, index) {
    return  <span>{CONSTANTS.TELEPHONY_EVENTS_NAMES[row.event_type]} (#{row.event_type})</span>
}